import Board from './Board';
import {
  NODE_COLOR_CLASS,
  TMT_GAME_NAME,
  type TmtStageConfig,
} from '@/pages/tmt/tmtConfig';

interface PracticeScreenProps {
  config: TmtStageConfig;
  path: string[];
  wrongId: string | null;
  completed: boolean;
  onSelect: (id: string) => void;
  onClose: () => void;
}

export default function PracticeScreen({
  config,
  path,
  wrongId,
  completed,
  onSelect,
  onClose,
}: PracticeScreenProps) {
  const hasCondition = !!config.ruleColor;

  return (
    <div className="flex flex-col h-full px-4 pt-3 pb-4 bg-white animate-fade-in-up">
      {/* 헤더: 게임명 + 연습 라벨 + 닫기 */}
      <div className="shrink-0 flex items-center justify-between mb-2">
        <span className="text-base font-bold text-foreground-900 whitespace-nowrap">
          {TMT_GAME_NAME}
        </span>
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-foreground-500 whitespace-nowrap">
            {config.stageLabel}
          </span>
          <button
            type="button"
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-full active:bg-secondary-100 transition-colors duration-150"
            aria-label="닫기"
          >
            <i className="ri-close-line text-xl text-foreground-700" />
          </button>
        </div>
      </div>

      {/* 안내 문구 */}
      <div className="shrink-0 flex flex-col items-center justify-center mb-1">
        <div className="flex items-center">
          {hasCondition && (
            <span
              className={`inline-block w-4 h-4 shrink-0 ${
                NODE_COLOR_CLASS[config.ruleColor!]
              } ${config.ruleShape === 'square' ? 'rounded-[3px]' : 'rounded-full'} mr-1.5`}
            />
          )}
          <span className="text-sm font-semibold text-foreground-700 whitespace-nowrap">
            {config.ruleHint}
          </span>
        </div>
        <span className="text-xs font-medium text-foreground-500 mt-0.5 whitespace-nowrap">
          노드를 누른 채 다음 노드까지 드래그해 연결하세요
        </span>
      </div>

      {/* 노드 보드 */}
      <div className="flex-1 min-h-0">
        <Board
          nodes={config.nodes}
          boardH={config.boardH}
          path={path}
          wrongId={wrongId}
          completed={completed}
          onSelect={onSelect}
          nodeSize={config.nodeSize}
        />
      </div>

      {/* 연습 완료 피드백 */}
      {completed && (
        <div className="shrink-0 flex items-center justify-center mt-2">
          <span className="inline-flex items-center px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-base font-bold whitespace-nowrap animate-pop-in">
            {config.completeMsg}
          </span>
        </div>
      )}
    </div>
  );
}